import { Component, Input, OnInit } from '@angular/core';
import { GetStatusByRepReport$Json$Params } from '../../../api/fn/report/get-status-by-rep-report-json';
import { ReportService } from '../../../api/services';
import { ToastService } from '../../../services/toast.service';
import { ClientRepStatusModel } from '../../../api/models';

@Component({
  selector: 'app-status-by-rep-grid',
  templateUrl: './status-by-rep-grid.component.html',
  styleUrl: './status-by-rep-grid.component.scss'
})
export class StatusByRepGridComponent implements OnInit {

  month: number;
  year: number;
  isReportLoading: boolean = false;
  statuses: ClientRepStatusModel[] = [];

  constructor(
    private reportService: ReportService,
    private toastService: ToastService
  ) {
  }

  ngOnInit() {
  }

  getStatusByRep(
    year: number,
    month: number,
  ) {
    if (this.isReportLoading === true) {
      // Avoid concurrent duplicate http requests if already loading.
      return;
    }
    // Make sure we don't have concurrent duplicate http requests.
    if (year === undefined || month === undefined) {
      return;
    }
    this.year = year;
    this.month = month;
    this.isReportLoading = true;

    let params: GetStatusByRepReport$Json$Params = {
      year: this.year,
      month: this.month
    };

    this.reportService.getStatusByRepReport$Json$Response(params).subscribe({
      next: (response) => {
        if (!response.body) {
          console.error(response.body);
          this.toastService.showToast('danger', 'Problem loading statusbyrep report');
        }
        else {
          this.statuses = [...response.body];
        }

        this.isReportLoading = false;
      },
      error: (e) => {
        this.isReportLoading = false;
        console.error('Error loading statusbyrep report:', e);
        this.toastService.showToast('danger', 'Problem loading statusbyrep report');
      }
    });
  }
}
